'use client';

import { LazyImage } from '@/components/ui/LazyImage';
import { cn } from '@/lib/cn';

const VIDEO_COVER_PATTERN = /\.(?:mp4|mov|webm|m4v)(?:[?#].*)?$/i;

export function isComposerSkillVideoCover(url: string): boolean {
  return VIDEO_COVER_PATTERN.test(url.trim());
}

export function ComposerSkillCoverMedia({
  src,
  alt,
  className,
  mediaClassName,
}: {
  src: string;
  alt: string;
  className?: string;
  mediaClassName?: string;
}) {
  if (isComposerSkillVideoCover(src)) {
    return (
      <video
        src={src}
        aria-label={alt || undefined}
        aria-hidden={alt ? undefined : true}
        className={cn('h-full w-full object-cover', className, mediaClassName)}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        disablePictureInPicture
        data-composer-skill-cover-video
      />
    );
  }

  return (
    <LazyImage
      src={src}
      alt={alt}
      aspectClass=""
      className={cn('h-full w-full', className)}
      imgClassName={cn('h-full w-full object-cover', mediaClassName)}
    />
  );
}
